import { fetcher } from '@commenda/utils';

const rephraseText = async (text: string) => {
  const response = await fetcher('ai-rephrase', {
    method: 'POST',
    body: { text },
  });

  return response;
};

export { rephraseText };
